import script from "./aboutUs.vue?vue&type=script&setup=true&lang=js"
export * from "./aboutUs.vue?vue&type=script&setup=true&lang=js"

import "./aboutUs.vue?vue&type=style&index=0&id=c46264f4&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c46264f4"]])

export default __exports__